/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayTeamTotalsDtoSchema = z.object({
  kills: z.optional(z.number()),
  deaths: z.optional(z.number()),
  assists: z.optional(z.number()),
  gold: z.optional(z.number()),
  damageToChampions: z.optional(z.number()),
  damageTaken: z.optional(z.number()),
  cs: z.optional(z.number()),
  visionScore: z.optional(z.number()),
  wardsPlaced: z.optional(z.number()),
  wardsKilled: z.optional(z.number()),
  controlWardsBought: z.optional(z.number()),
  turrets: z.optional(z.number()),
});
